module.exports = __webpack_public_path__ + "videos/video-768@2x.27f653f.mp4";